
import {
    fetchTrack as fetchTrackActions,
    fetchTracksFailure,
    fetchTracksRequest,
    fetchTracksSuccess,
    updateTrackProgress,
} from '../actions';
import { IUpdate } from '../api';
import { IPageInfo } from '../reducers';
import { ThunkAction } from "../types";

const PAGE_SIZE = 100;

export function downloadTrack(trackID: string): ThunkAction {
  return async (_, getState) => {
    const {tracks} = getState();
    const track = tracks.data[trackID];
    if (!track) {
      return;
    }

    const filename = track.id + track.extension;

    const link = document.createElement("a");
    link.download = filename;
    link.href = track.url;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
}

export function fetchTrack(trackID: string, opts: {full: boolean} = {full: false}): ThunkAction {
  return async (dispatch, getState, {audiostore}) => {
    try {
      const {tracks} = getState();
      const cached = tracks.data[trackID];
      if (cached && (!opts.full || cached.url)) {
        return;
      }

      dispatch(fetchTrackActions.request());

      const track = await audiostore.get(trackID);

      dispatch(fetchTrackActions.success(track));

    } catch(error) {
      dispatch(fetchTrackActions.failure(error));
    }
  }
}


export function updateTrack(trackID: string, update: IUpdate): ThunkAction {
  return async (dispatch, getState, {audiostore}) => {
    try {
      dispatch(updateTrackProgress.request(update));

      const track = await audiostore.update(trackID, update);

      dispatch(updateTrackProgress.success(track));

    } catch(error) {
      dispatch(updateTrackProgress.failure(error));
    }
  }
}

export function fetchTrackPage(page: number | null): ThunkAction {
    return async (dispatch, getState, {audiostore}) => {
      const {pages} = getState().tracks;
      if (page === null) {
        page = pages.length;
      }
  
      try {
        const isLoading = pages.find((info: IPageInfo) => info.loading);
        if (isLoading) {
          return;
        }

        await dispatch(fetchTracksRequest(undefined, {page}));
  
        const results = await audiostore.list({
          limit: PAGE_SIZE,
          offset: page * PAGE_SIZE
        });
  
        await dispatch(fetchTracksSuccess(results, {page}));
      } catch (error) {
        await dispatch(fetchTracksFailure(error, {page}));
        return;
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/thunks/trackThunks.ts